import type VueI18n from 'vue-i18n'
import type { AxiosInstance } from 'axios'
import _ from 'lodash'
import { registerI18n } from './i18n/i18n'
import { Service } from './service/service'
import { IUrlsConfig } from './service/urls'

export interface IContextConfig {
    disabled?: boolean
    urls: IUrlsConfig
    i18n: VueI18n

    // 不显示button, 默认false
    hiddenButton?: boolean

    //can lazy set
    transfer?: AxiosInstance

    //internel
    debug?: boolean
}

interface IDialog {
    Show:() => any
    Hidden:() => any
}
export class Context {
    Service: Service = null
    private _dialog: IDialog|null = null
    constructor(public config: IContextConfig) {
        const {
            i18n,
            transfer,
            urls,
            disabled,
        } = config
        if (disabled) {
            return
        }

        registerI18n(i18n)
        this.Service = new Service({
            i18n,
            urls,
            transfer,
        })
        this.Service._originContextConfig = {...config}
        // @ts-ignore
        window['$$CaseTimeContext'] = this
    }

    set Transfer(transfer: AxiosInstance) {
        if (this.Service) {
            this.Service.setTransfer(transfer)
        }
    }

    get CaseTimeDetailUrl() {
        return this.Service.passport.CaseTimeDetailUrl
    }

    setDialog(dialog: IDialog) {
        this._dialog = dialog
    }

    showDialog(params?: {warnMsg:string, msgType: 'warning'|'error'}) {
        if (this._dialog && _.isFunction(this._dialog.Show)) {
            this._dialog.Show(params)
        }
    }

    hideDialog() {
        if (this._dialog && _.isFunction(this._dialog.Show)) {
            this._dialog.Hidden()
        }
    }
}

export function createContext(config: IContextConfig) {
    return new Context(config)
}
